module.exports = __webpack_public_path__ + "static/media/Expired-small.6e7090f0.svg";